/**
 *
 */
export const ensureResizeObserver = async (): Promise<
  typeof ResizeObserver
> => {
  if (typeof window === 'undefined') {
    throw new Error('No ResizeObserver in SSR')
  }
  if (!('ResizeObserver' in window)) {
    const module = await import('@juggle/resize-observer')

    // TypeScript thinks ResizeObserver always exists in window but it may not
    // be the case for legacy browsers. We need to cast it to any to avoid TS
    // complains window is `never` type in this block.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(window as any).ResizeObserver = module.ResizeObserver
  }
  return window.ResizeObserver
}
